export default {
  common: {
    contact: {
      name: "O'Sol<br>Nicolas Roggemans",
      tel: '+34 655 21 25 97',
      email: 'info@osol.es',
      web: 'http://www.osol.es'
    },
    brochures: {
      fr: [
        {
          title: "O'Sol",
          path: 'osol-fr.pdf'
        }
      ]
    }
  },
  costa_del_sol: {
    contact: {
      name: "Made with love",
      tel: '+34 627 764 708<br>+34 673 618 547',
      email: 'info@madewithlove.pro',
      web: 'http://www.madewithlove.pro'
    },
    brochures: {
      fr: [
        {
          title: "Made with Love",
          path: 'made-with-love-fr.pdf'
        }
      ],
      nl: [
        {
          title: "Made with Love",
          path: 'made-with-love-nl.pdf'
        }
      ]
    }
  }
};


// WEBPACK FOOTER //
// ./src/data/keyholding.js